import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiGithubFill } from '@remixicon/react';
import { rootRouteRef } from './routes';

export const githubLandingPage = PageBlueprint.make({
  params: {
    path: '/github',
    // Configurable as `title` of `page:github-landingpage` in `app.extensions`.
    title: 'GitHub',
    icon: <RiGithubFill />,
    // LINK THE ROUTE HERE:
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/github-landingpage').then(m => (
        <m.GithubLandingPage />
      )),
  },
});

export const githubLandingPagePlugin = createFrontendPlugin({
  // The plugin ID is now provided as `pluginId` instead of `id`
  pluginId: 'github-landingpage',
  // bind all the extensions to the plugin
  extensions: [githubLandingPage],
  // Adding the routes mapping here ensures navigation works
  routes: {
    root: rootRouteRef,
  },
});
